import { render, staticRenderFns } from "./supplierStatement.vue?vue&type=template&id=21ae2d2c"
import script from "./supplierStatement.vue?vue&type=script&lang=js"
export * from "./supplierStatement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports